// Rewrites parenthetical (negative) dollar amounts to $0.00, leaving other text untouched.
// Examples:
//   "($70.00)"        -> "$0.00"
//   "\n($1,070.00)\n" -> "\n$0.00\n"   (surrounding whitespace preserved)
//   "$240.00"         -> "$240.00"     (unchanged)
//   "Subtotal"        -> "Subtotal"    (unchanged)
const PARENTHETICAL_PRICE = /\(\$[\d,]+\.\d{2}\)/g;

export function rewriteCreditText(text: string): string {
    return text.replace(PARENTHETICAL_PRICE, '$0.00');
}
